import * as THREE from "../../../../libs/three.js/build/three.module.js"; 
import {CameraAnimation} from './CameraAnimation.js'
import {CameraAnimationCurve} from './CameraAnimationCurve.js'
import {  transitions } from '../../utils/transitions.js'

let CamAniEditor = {
    
    
     
    
    createAnimation(data){
        let animation = new CameraAnimation(viewer, data.tension);
        if(data) { 
            animation.name = data.name;
            animation.duration = data.duration;
            animation.useDurSlice = data.useDurSlice 
              
            for(const cpdata of data.points){ 
                /* const position = Potree.Utils.datasetPosTransform({ fromDataset: true, position: cpdata.position, datasetId: Potree.settings.originDatasetId })
                const target = Potree.Utils.datasetPosTransform({ fromDataset: true, position: cpdata.target, datasetId: Potree.settings.originDatasetId })
                 */
                const position = new THREE.Vector3().copy(cpdata.position)
                const target = new THREE.Vector3().copy(cpdata.target)  
                const duration = cpdata.time
                const cp = animation.createControlPoint(null, {position, target, duration}); 
            }
        }
        
        animation.changeCallback()
        viewer.scene.addCameraAnimation(animation);
         
        return animation
        
    },
    
    
    removeAnimation(animation){
        animation.dispatchEvent('dispose')
        viewer.scene.removeCameraAnimation(animation)
    },
    
    
    
     
     
    createMulAnimation(data){//新版，包含漫游点
        let event_ = new THREE.EventDispatcher
        let sections = [] //分段, 分成animation和漫游点
        let aniIndex = 0
        let curAni, addAnimation = ()=>{ 
            if(curAni){ 
                let data_ = {
                    name : 'animation_'+aniIndex,
                    duration:  curAni.slice(0, curAni.length - 1).reduce(function (total, currentValue) { return total + currentValue.time }, 0), //总时长(要去掉最后一个，因为已到终点，该点time无意义)
                    useDurSlice: data.useDurSlice,
                    points: curAni
                } 
                let ani = this.createAnimation(data_) 
                sections.push(ani)
                ani.originIndexStart = data.points.indexOf(curAni[0]) 
                ani.addEventListener('updateCurrentIndex',(e)=>{
                    emitIndex(e.currentIndex) 
                })
                curAni = null
            }
        }
        data.points.forEach((e,i)=>{//切分为若干个animation，中间是漫游点的衔接
            if(e.panoId != void 0){ //暂定:有panoId的都是全景图模式
                let pano = e.model.panos.find(a=>a.originID == e.panoId)
                if(pano){
                    addAnimation()  //如果前面是动画，先截断  
                    e.pano = pano
                    e.rotInModel = new THREE.Quaternion().fromArray(e.rotInModel)
                    e.quaternion = Potree.Utils.datasetRotTransform({ fromDataset: true, quaternion: e.rotInModel, getQuaternion: true, object:e.model })  

                    sections.push(e)
                    
                } 
            }else{
                if(curAni){
                    curAni.push(e)
                }else{//非pano
                    if(sections.length>0){
                        let last = sections[sections.length-1] //因为要从上一个pano出来，所以起始点是上一个pano
                        last.position = last.pano.position
                        last.target = last.position.clone().add(new THREE.Vector3(0,0,-1).applyQuaternion(last.quaternion))
                        curAni = [last,e]   
                    }else{
                        curAni = [e]
                    } 
                }
            }
        })
        addAnimation()
        
        
        
        
        
        
        let currentPlay 
        let emitIndex = (indexInAni=0)=>{
            let ani = sections[currentPlay] 
            let currentIndex = 0
            if(ani instanceof CameraAnimation){
                currentIndex = ani.originIndexStart + indexInAni
            }else{
                currentIndex = Math.max(0, data.points.indexOf(ani) - 1)
            }
            event_.dispatchEvent({type:'updateCurrentIndex', currentIndex  })    
        }
        
        let result = {
            event_,
            
            play(){//从头播放 
                
                let playNext = (index)=>{
                    if(index == sections.length){
                        return event_.dispatchEvent('playDone')
                    }
                    
                    let ani = sections[index]
                    currentPlay = index 
                    emitIndex()
                    
                    if(ani instanceof CameraAnimation){
                        Potree.settings.displayMode = 'showPointCloud'
                        ani.addEventListener('playDone', () => {
                            playNext(index + 1)
                        },{once:true}) 
                        ani.play()
                    }else{
                        let pano = ani.pano
                        let last = sections[index-1],  duration,  quaternion = ani.quaternion
                        if(last){ 
                            if(last instanceof CameraAnimation){
                                duration = last.durations[last.durations.length - 1] //最后一个时间
                            }else{
                                duration = last.time 
                            }
                            duration *= 1000
                        }else{
                            duration = 600 //起始
                        }
                        viewer.images360.flyToPano({pano, quaternion, duration, callback:()=>{
                            
                            let next = ()=>{
                                let stayTime = (!sections[index-1] || sections[index-1] instanceof CameraAnimation) && sections[index+1] && sections[index+1] instanceof CameraAnimation ? 1000 : 300  //前后都是点云模式的话停留久一点。最好在页面上能设置
                                console.log('stayTime',stayTime)
                                setTimeout(()=>{
                                    currentPlay != void 0 && playNext(index + 1)
                                },stayTime) //稍作停留，不然点云-全景-点云的话根本看不到全景
                            }
                            if(/* ani.displayMode == 'showPanos' &&  */Potree.settings.displayMode != 'showPanos'){//刚加载完就飞走吗？
                                Potree.settings.displayMode = 'showPanos'
                                viewer.images360.addEventListener('endChangeMode',()=>{
                                    next()
                                },{once:true})  
                            }else{
                                next()
                            }
                            //
                        }}) 
                    }
                }
                playNext(0)
                
           
            },
            
            stop(){
                let ani = sections[currentPlay]
                if(ani instanceof CameraAnimation){
                    ani.pause()
                }else{
                    let view = viewer.mainViewport.view
                    if(!view.isFlying('pos')){//前后是相同漫游点，仅旋转
                        view.cancelFlying('rotate')
                    }else{//加快结束
                        let o = transitions.getById(view.FlyTransition)[0]
                        let restDur = o.duration - o.current;
                        const hopeStopTime = 300 //希望最多等待时间
                        if(restDur>hopeStopTime){
                            let r = o.duration / (o.current + hopeStopTime)
                            transitions.adjustSpeed(view.FlyTransition, r)
                            transitions.adjustSpeed(view.LookTransition, r)
                        } 
                    } 
                    //如果有地图，还要改地图的view
                    
                }
                
                currentPlay = null
            },
            
            remove(){
                sections.forEach(ani=>{
                    if(ani instanceof CameraAnimation){
                        CamAniEditor.removeAnimation(ani) 
                    }
                })
            }
            
            //再把中间的缓动去除
            
        }
        return result 
    },
        
        
        
        
   
    
    
    createCurveAni(curve, duration, tangentDt){
        let ani = new CameraAnimationCurve(curve, duration, tangentDt )
        
        return ani
    }
    
    
    
    
}



  



export default CamAniEditor